// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__u1kLw","footer":"ModalFilter_footer__36FDm"};